module.exports = __webpack_public_path__ + "media/images/spree/frontend/content/sizing/step0-677242f121d43e26bd6488e257d30f08.jpg";